import { PackageBuildModal } from '../../../components/collections/PackageBuildModal'
import { useCollectionTargets, usePackageBuild } from '../../../hooks'

interface PackageBuildModalWrapperProps {
  caseId: string
  requestId: string
  hasTemplate: boolean
  onClose: () => void
}

export function PackageBuildModalWrapper({
  caseId,
  requestId,
  hasTemplate,
  onClose,
}: PackageBuildModalWrapperProps): React.ReactElement {
  const {
    status,
    building,
    downloading,
    downloadComplete,
    error,
    build,
    download,
    pollStatus,
    stopPolling,
  } = usePackageBuild()
  const { targets } = useCollectionTargets(caseId, requestId)
  return (
    <PackageBuildModal
      open
      onClose={onClose}
      status={status}
      building={building}
      downloading={downloading}
      downloadComplete={downloadComplete}
      hasTemplate={hasTemplate}
      targetCount={targets.length}
      error={error}
      onBuild={() => {
        void build(caseId, requestId)
      }}
      onBuildCollectorOnly={() => {
        void build(caseId, requestId, true)
      }}
      onDownload={() => {
        void download(caseId, requestId)
      }}
      onStartPolling={() => {
        pollStatus(caseId, requestId)
      }}
      onStopPolling={stopPolling}
    />
  )
}
